export const ITEMS_PER_PAGE = 10;

export const INITIAL_INVENTORY_ARTICLE_STATE = {
  uuid: null,
  code: '',
  name: '',
  description: '',
  uuid_unit: '',
  external_code: '',
  is_active: true,
};

export const VALIDATION_RULES = {
  REQUIRED_FIELDS: ['code', 'name'],
  CODE_MAX_LENGTH: 50,
  NAME_MAX_LENGTH: 150,
  EXTERNAL_CODE_MAX_LENGTH: 80,
};

export const MESSAGES = {
  ERROR: {
    REQUIRED_FIELD: 'Este campo es obligatorio',
    INVALID_CODE: 'El código no puede estar vacío',
    INVALID_NAME: 'El nombre no puede estar vacío',
    INVALID_QUANTITY: 'La cantidad debe ser mayor a cero',
    REQUIRED_REASON: 'El motivo es obligatorio',
    REQUIRED_WAREHOUSE: 'El depósito es obligatorio',
    NEGATIVE_STOCK: 'El egreso no puede dejar stock físico negativo',
  },
};

export const ADJUSTMENT_TYPES = {
  IN: 'in',
  OUT: 'out',
};

export const ADJUSTMENT_TYPE_OPTIONS = [
  { value: ADJUSTMENT_TYPES.IN, label: 'Ingreso' },
  { value: ADJUSTMENT_TYPES.OUT, label: 'Egreso' },
];

export const INITIAL_ADJUST_STOCK_STATE = {
  uuid_warehouse: '',
  adjustmentType: ADJUSTMENT_TYPES.IN,
  quantity: '',
  reason: '',
};

export const MOVEMENT_TYPE_LABELS = {
  transfer_in: 'Ingreso por traslado',
  transfer_out: 'Egreso por traslado',
  consumption: 'Consumo',
  adjustment_in: 'Ajuste de ingreso',
  adjustment_out: 'Ajuste de egreso',
  reservation: 'Reserva',
  reservation_release: 'Liberación de reserva',
  reversal: 'Reversión',
};

export const ALL_WAREHOUSES_FILTER = 'all';

export const MATERIAL_HISTORY_TEXTS = {
  fifoSources: 'Fuentes FIFO y remanentes por depósito',
  purchaseHistory: 'Histórico de costos por compra',
  loadError: 'No se pudo consultar el histórico',
};

export const MATERIAL_HISTORY_VALUATION_BASIS = 'historical_ars';

/** Estados de un artículo para el chip de la tabla. */
export const INVENTORY_ARTICLE_STATUS_CONFIG = {
  active: { label: 'Activo', color: 'success' },
  inactive: { label: 'Inactivo', color: 'default' },
};

/** Opciones de estado del formulario de edición de artículo. */
export const INVENTORY_ARTICLE_STATUS_OPTIONS = [
  { value: 'active', label: 'Activo' },
  { value: 'inactive', label: 'Inactivo' },
];

/** Opciones del filtro de estado del listado de artículos. */
export const INVENTORY_ARTICLE_STATUS_FILTER_OPTIONS = [
  { value: 'all', label: 'Todos' },
  { value: 'active', label: 'Activos' },
  { value: 'inactive', label: 'Inactivos' },
];

export const INVENTORY_ARTICLES_FILTER_TEXTS = {
  search: 'Buscar',
  searchPlaceholder: 'Código, nombre, descripción o código externo',
  status: 'Estado',
};

export const INVENTORY_ARTICLES_TABLE_TEXTS = {
  code: 'Código',
  name: 'Nombre',
  description: 'Descripción',
  unit: 'Unidad',
  externalCode: 'Código externo',
  status: 'Estado',
  actions: 'Acciones',
  view: 'Ver detalle',
  edit: 'Editar',
  delete: 'Eliminar',
  empty: 'No se encontraron artículos de inventario',
};

export const INVENTORY_ARTICLE_FORM_TEXTS = {
  createTitle: 'Nuevo artículo',
  editTitle: 'Editar artículo',
  code: 'Código',
  name: 'Nombre',
  description: 'Descripción',
  unit: 'Unidad de medida',
  unitPlaceholder: 'Buscar unidad',
  noUnit: 'Sin unidad',
  externalCode: 'Código externo',
  status: 'Estado',
  create: 'Crear',
  update: 'Actualizar',
};

export const ARTICLE_STOCK_TABLE_TEXTS = {
  warehouse: 'Depósito',
  onHand: 'Stock físico',
  reserved: 'Stock reservado',
  available: 'Stock disponible',
  actions: 'Acciones',
  adjust: 'Ajustar stock',
  empty: 'No hay stock registrado para este artículo',
};

export const ARTICLE_MOVEMENTS_TABLE_TEXTS = {
  warehouseFilter: 'Depósito',
  warehouseFilterPlaceholder: 'Buscar depósito',
  allWarehouses: 'Todos los depósitos',
  date: 'Fecha',
  warehouse: 'Depósito',
  type: 'Tipo',
  quantity: 'Cantidad',
  previous: 'Stock anterior',
  next: 'Stock nuevo',
  reason: 'Motivo',
  empty: 'No hay movimientos para mostrar',
};

export const ADJUST_STOCK_TEXTS = {
  title: 'Ajustar stock',
  article: 'Artículo',
  warehouse: 'Depósito',
  warehousePlaceholder: 'Buscar depósito',
  currentStock: 'Stock actual',
  adjustmentType: 'Tipo de ajuste',
  quantity: 'Cantidad',
  reason: 'Motivo',
  estimatedStock: 'Stock resultante estimado',
  save: 'Guardar ajuste',
  saveError: 'No se pudo ajustar el stock',
};
